import script from "./MaxLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxLogin.vue?vue&type=script&setup=true&lang=js"

import "./MaxLogin.vue?vue&type=style&index=0&id=489e2f00&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489e2f00"]])

export default __exports__